export default {
  headerTable: '14px',
  button: '14px',
  actionsButtonHeader: '13px',
  actionsButtonSmallerHeader: '10px',
  tableRowText: '14px',
  messageParagraph: '13px',
  text: '16px',
};
